import $http from "../../axios";
import {
    Notification,
    MessageBox
} from 'element-ui';

// obtener los tipos de comprobante
export async function fetchVouchertype({commit, state}) {
    await $http.get('/api/tipos-de-comprobantes', { params : state.paramsVoucherType})
        .then((response) => {
            commit('setVouchersTypes', response.data.data)
        })
        .catch((error) => {
            Notification.error({
            title: 'Error!',
            message: error.message,
            type: 'error',
            duration: 2000,
            customClass: 'notification-box',
        });
    })
}

// obtener Data libro Contable
export async function fetchReportData({commit, state}) {
    state.params.branchoffice_id =
    await $http.get('/api/detalle-contable-documento', { params : state.params})
        .then((response) => {
            commit('setReportData', response.data.data);
            state.loading.module = false;
        })
        .catch((error) => {
            Notification.error({
            title: 'Error!',
            message: 'Error',
            type: 'error',
            duration: 2000,
            customClass: 'notification-box',
        });
    })
}



// WEBPACK FOOTER //
// ./src/modules/accounting-detail/actions.js